'use strict';

const jQuery = require('jquery');

const Repository = require('./repository/BundleRepository');
const Mediator = require('./../../core/mediator');
const Translator = require('./../../core/translator');
const Zone = require('./../../services/structure/zone');
const Loader = require('./../../services/loader');
const Notifier = require('./../../services/notifier');
const Overlay = require('./../../services/overlay');
const PopinManager = require('./../../services/popin');

const itemTpl = require('./template/item.hbs');

let $adminContainer;
let $smallPanel;

module.exports.onMenuClick = () => {
    let $container = jQuery('<ul class="cloud-list list-unstyled"></ul>');

    Repository.findAll().done((bundles) => {
        bundles.forEach((bundle) => {
            let $item = jQuery(itemTpl({'label': Translator.translate('bundle_' + bundle.id)}));

            $item.on('click', () => Mediator.publish('on:bundle:click', bundle));
            $container.append($item);
        });
    });

    Zone.addLayer(Translator.translate('bundle_management'), $container);
};

module.exports.updateUi = function(url, data) {
    Loader.start($adminContainer);
    Repository.getByUrl(url, data).done((template) => {
        $adminContainer.html(template);
        module.exports.translateKey();
        Loader.stop($adminContainer);
    }).fail(() => {
        Notifier.error(Translator.translate('an_error_occured'));
        Loader.stop($adminContainer);
    });
};

module.exports.setSmallPanelContent = ($content) => {
    $smallPanel.find('.panel-bundle-container').html($content);
};

module.exports.setSmallPanelFooter = ($content) => {
    Zone.setFooter($smallPanel, $content);
};

module.exports.translateKey = () => {
    $adminContainer.find('[data-cloud-trans]').each(function() {
        jQuery(this).html(Translator.translate(jQuery(this).attr('data-cloud-trans')));
    });

    let attr = 'data-cloud-attr-trans';
    $adminContainer.find(`[${attr}]`).each(function() {
        let $current = jQuery(this);

        $current.removeAttr(attr);
        jQuery.each($current.get(0).attributes, function(key, attribute) {
            let value = attribute.value;
            if (typeof value === 'string' && value.includes('trans:')) {
                $current.attr(attribute.name, Translator.translate(value.substring(6)));
            }

            return key;
        });
    });
};

module.exports.createPopin = (config = {}, isPopover) => {
    config.position = {my: 'center center', at: 'center center', of: jQuery('.cloud-panel-fullpage')};

    let popin = PopinManager.createPopin(config);

    popin.on('open', function() {
        setTimeout(function() {
            Overlay.show({
                'onClick': function() {
                    return;
                },
                'classes': 'bundle-overlay',
                'appender': $adminContainer,
            });
        }, 100);
    });

    popin.on('close', function() {
        jQuery('.bundle-overlay').remove();
    });

    return popin;
};

module.exports.request = (url, data, method) => {
    return Repository.request(url, data, method);
};

module.exports.onBundleClick = (bundle) => {
    let $container = jQuery('<div class="panel-bundle-container"></div>');
    $adminContainer = jQuery('<div class="admin-container"></div>');

    $container.append(`<div class="cloud-liner"></div><p>${Translator.translate('bundle_' + bundle.id + '_description') || ''}</p>`);

    module.exports.updateUi(bundle['bundle_admin_entrypoint']);

    $adminContainer.on('click', 'a', function(e) {
        let $current = jQuery(this);
        let href = $current.attr('href');

        if (href && $current.attr('prevent-update') === undefined) {
            e.preventDefault();

            module.exports.updateUi(jQuery(this).attr('href'));
        }
    });

    $smallPanel = Zone.addLayer(Translator.translate('bundle_' + bundle.id), $container);
    Zone.setFullPanel(Translator.translate('bundle_' + bundle.id + '_admin'), $adminContainer);
};
